var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-combo-multiselect" },
    [
      _c(
        "vue-multiselect",
        {
          ref: "multiselect",
          attrs: {
            clearOnSelect: false,
            closeOnSelect: false,
            deselectLabel: "",
            internalSearch: false,
            label: "text",
            multiple: true,
            options:
              _vm.searchText.length < _vm.minSearchLength ? [] : _vm.options,
            loading: _vm.loading,
            placeholder: "",
            "preselect-first": false,
            preserveSearch: true,
            searchable: true,
            selectedLabel: "",
            selectLabel: "",
            taggable: false,
            trackBy: "value",
          },
          on: {
            open: _vm.onOpen,
            close: _vm.onClose,
            remove: _vm.onRemove,
            "search-change": _vm.onSearchChange,
          },
          model: {
            value: _vm.selected,
            callback: function ($$v) {
              _vm.selected = $$v
            },
            expression: "selected",
          },
        },
        [
          _c("template", { slot: "noOptions" }, [
            _c("span", [_vm._v(_vm._s(_vm.noOptionsMessage))]),
          ]),
          _vm._v(" "),
          _c("template", { slot: "noResult" }, [
            _c("span", [_vm._v(_vm._s(_vm.noOptionsMessage))]),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _vm.searchText && _vm.searchText.length < _vm.minSearchLength
        ? _c("div", { staticClass: "search-helper-text" }, [
            _vm._v("\n        " + _vm._s(_vm.noOptionsMessage) + "\n    "),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }